// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__-7VQi","row":"Node_row__Wydsq","label":"Node_label__c58aC","footer":"Node_footer__3gNM0"};